<template>

<v-menu v-model='showdetail' >
  <template open-on-hover v-slot:activator="{ on }">
    <v-btn small icon
      v-show='tables && tables.length > 0'
      v-on='on'
      slot='activator'
      @click.stop='showdetail=true'
      :loading='req.loading' >
      <v-icon color='amber' >flash_on</v-icon>
    </v-btn>
  </template>
  <v-card>
    <v-card-title class='overline py-1 grey darken-3 white--text' >
      <v-icon small color='amber' class='mr-1' >flash_on</v-icon>
      The following codes will automatically be added to this appointment
      <v-spacer/>
      <v-btn icon small dark
        @click='showdetail=false' ><v-icon  >close</v-icon></v-btn>
    </v-card-title>
    <v-divider/>
    <v-card v-for='(table, index) in tables' :key='`${index}-${table.id}`' class='ma-2' >
      <v-card-title class='overline grey lighten-4' v-text='table.title' />
      <v-data-table
        dense hide-actions hide-default-footer disable-initial-sort
        disable-sort disable-filter disable-pagination
        no-data-text='No autocodes found'
        :headers="table.headers"
        :items="table.codes"
        :items-per-page="10" >
        <template v-slot:items="props" >
          <td>{{ props.item.icd10 || '-' }}</td>
          <td>{{ props.item.process || '-' }}</td>
          <td>
            <span v-if='props.item.price' >
              {{ formatCurrency(props.item.currency, props.item.price) }}
            </span>
            <span v-else >-</span>
          </td>

          <template v-if="table.id === 'client'" >
            <td >{{ dateformat(props.item.start_date) }}</td>
            <td >
              <span v-if='props.item.stop_date' v-text='props.item.stop_date' />
              <span v-else >No end date</span>
            </td>
          </template>
        </template>
      </v-data-table>
      <v-footer v-if='table.footertext' class='caption py-0 pl-2 hidden-xs-only' v-text='table.footertext' />
    </v-card>
    <v-divider/>
    <!-- <pre v-text='autocodes' /> -->
  </v-card>
</v-menu>

</template>
<script>
export default {
  name: 'AutomationIndicator',
  props: {
    practitionerId: { required: false },
    relationshipId: { required: false },
    productId: { required: false },
    dt: { required: false }
  },
  data () {
    return {
      showdetail: false,
      req: {
        resource: 'ag.spaces.relationships',
        extra: 'autocodes'
      },
      productheaders: [
        { text: 'ICD-10', value: 'icd10' },
        { text: 'Process', value: 'process' },
        { text: 'Price', value: 'price' }
      ],
      headers: [
        { text: 'ICD-10', value: 'icd10' },
        { text: 'Process', value: 'process' },
        { text: 'Price', value: 'price' },
        { text: 'Valid from', value: 'start_date' },
        { text: 'Valid till', value: 'stop_date' }
      ]
    }
  },
  computed: {
    watchString () {
      return `${this.practitionerId}-${this.dt}-${this.relationshipId}-${this.productId}`
    },
    isValid () {
      return this.practitionerId && this.dt && this.relationshipId
    },
    autocodes () {
      let codes = this.getObjectPath(this.req, 'result')
      if (codes && Array.isArray(codes)) { return codes }
      return this.getObjectPath(this.req, 'result.client', [])
    },
    productAutocodes () {
      return this.getObjectPath(this.req, 'result.product', [])
    },
    tables () {
      let t = []
      if (this.req.status === 404) { return [] }
      if (this.autocodes && this.autocodes.length > 0) {
        t.push({
          id: 'client',
          title: 'Code automatically added for client',
          headers: this.headers,
          codes: this.autocodes,
          footertext: 'You can edit autocodes for a client from the client detail page under the "codes" tab'
        })
      }
      if (this.productAutocodes && this.productAutocodes.length > 0) {
        t.push({
          id: 'product',
          title: 'Code automatically added due to appointment type',
          headers: this.productheaders,
          codes: this.productAutocodes,
          footertext: 'You can add autocodes for an appointment type from the edit screen in advanced settings (settings.appointmentguru.co)'
        })
      }
      return t
    },
    payload () {
      let data = {
        dt: this.dt,
        practitioner: this.practitionerId
      }
      if (this.productId) { data['product'] = this.productId }
      return data
    }
  },
  watch: {
    watchString: {
      immediate: true,
      handler () { this.check() }
    }
  },
  methods: {
    check () {
      if (this.isValid) {
        this.req.resourceId = this.relationshipId
        this.req.params = this.payload
        this.$request('get', this.req)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// AutomationIndicator.vue?5dc05b48